export interface OracleQuoteInfo {
    oracleAccount: string;
    baseMint: string;
    lastUpdateTime: number;
    spotPrice: number;
    twapPrice: number;
    marketPrice?: number;
    uncertainty: number;
    nowTimestamp: number;
}

export enum UncertaintyType {
    Skip,
    Add,
    Subtract
}

export interface OracleQuote {
    usdPrice: number;
    marketPrice: number;
    oracleAccount: string;
    getUsdAmount: <T extends number | undefined>(amount: T, decimals?: number, uncertaintyType?: UncertaintyType) => T;
    baseQuotes: OracleQuoteInfo[];
    uncertainty: number;
}

export enum OracleType {
    PythLegacy = 0,
    StakePoolLST = 1,
    MeteoraLP = 2,
    MeteoraVault = 3,
    SwitchboardOnDemand = 4,
    OrcaWhirlpool = 5,
    Pyth = 6,
    Flp = 7,
    LoopscaleVaultLp = 8,
    ExponentToken = 9,
    StabbleLpToken = 10,
    PerenaLpToken = 11,
    RatexPtToken = 12,
    AdrenaLpToken = 13,
    EtherFuseStableBond = 14,
    // Fx oracle type is used for pricing other tokens that need FX rates only. Currently not used as standalone oracle type.
    // It is also a pyth oracle type, just without a real token attached.
    // It is also inverted.
    Fx = 15,
    RaydiumCLMM = 16,
    ExponentLpToken = 17,
    ExponentDiscountToMaturity = 18,
    // An indirection, not a source; OracleProvider says what actually priced it.
    BeamAccount = 19
}

// What priced an asset, resolved server-side so the client never has to know
// whether the price came directly from a provider or through a beam. A string
// so it can't be confused with the numeric OracleType sitting beside it.
export type OracleProvider =
    | "unknown"
    | "pyth_legacy"
    | "pyth"
    | "chainlink"
    | "redstone"
    | "switchboard"
    | "stake_pool"
    | "meteora_lp"
    | "meteora_vault"
    | "orca_whirlpool"
    | "raydium_clmm"
    | "flp"
    | "loopscale_vault_lp"
    | "loopscale_nav"
    | "exponent_token"
    | "exponent_lp_token"
    | "exponent_discount_to_maturity"
    | "exponent_tranche"
    | "jupiter_lend"
    | "stabble_lp_token"
    | "perena_lp_token"
    | "ratex_pt_token"
    | "adrena_lp_token"
    | "ether_fuse_stable_bond"
    | "fx";
